import { DonationFormCategory, getVariableHtml, StaticVariableTag } from "@simplyk/common";

import { GetCurrentUserFrontendObject } from "@/common/contexts/types";
import { Translate } from "@/common/hooks/useTranslate";

export interface DonationFormEmailTemplates {
  emailObject: string;
  emailContent: string;
}

/**
 * Generates default email templates for donation forms based on category.
 * This is used both for initial form creation and as fallback when AI generation fails.
 */
export const getDonationFormEmailTemplates = (
  formCategory: DonationFormCategory,
  t: Translate,
  currentUser: GetCurrentUserFrontendObject | null | undefined
): DonationFormEmailTemplates => {
  const sanitizedEmail = currentUser?.email ? currentUser.email : null;

  const formEmailBodyPlaceholder =
    t("dashboard", "donationForm.defaultFormEmailBody1") +
    getVariableHtml({ text: t("dashboard", "common.firstName"), tag: StaticVariableTag.FirstName }) +
    t("dashboard", "donationForm.defaultFormEmailBody2", {
      firstName: currentUser?.firstName || "",
      lastName: currentUser?.lastName || "",
      email: sanitizedEmail || "",
    });

  return {
    emailObject: t("common", "thankYouForYourSupport"),
    emailContent: formEmailBodyPlaceholder,
  };
};
